export function DFlexResponsive({
  children,
  display = "flex",
  flex = "row",
  justifyContent = "center",
  alignItems = "center",
}) {
  return (
    <div
      className={`
        d-grid align-items-${alignItems} gap-2        
        d-md-${display} flex-md-${flex} justify-content-md-${justifyContent}
        d-xl-${display} flex-xl-${flex} justify-content-xl-${justifyContent} 
      `}
    >
      {children}
    </div>
  );
}
